import { render, staticRenderFns } from "./ProgramDocuments.vue?vue&type=template&id=18d0c786&scoped=true&"
import script from "./ProgramDocuments.vue?vue&type=script&lang=ts&"
export * from "./ProgramDocuments.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramDocuments.vue?vue&type=style&index=0&id=18d0c786&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d0c786",
  null
  
)

export default component.exports